import React from "react";
import logo_footer from "../assets/imgs/vnpt.png";
import bocongthuong from "../assets/imgs/bocongthuong.png";
const Footer = () => {
  return (
    <div className="py-10  bg-[#1679CF]">
      <div className="w-4/5 mx-auto flex flex-col lg:flex-row items-end justify-between">
        <div className="text-sm w-full text-center flex flex-col lg:flex-row lg:gap-16 xl:w-auto xl:text-left ">
          <img src={logo_footer} alt="VNPT" className="lg:mb-4 lg:h-12 h-8 w-28 lg:w-40 mx-auto" />
          <ul className="space-y-2 mt-2 text-white">
            <li>
              Cơ quan quản lý:
              <span className="block md:inline">
                {" "}
                Tập đoàn Bưu chính Viễn thông Việt Nam
              </span>
            </li>

            <li>
              Chịu trách nhiệm quản lý nội dung:
              <span className="block md:inline">
                {" "}
                Ông Vũ Trường Giang – TGĐ VNPT-Media
              </span>
            </li>

            <li>
              Địa chỉ: Số 57 Phố Huỳnh Thúc Kháng, Phường Láng, Thành phố Hà Nội
            </li>

            <li>
              SĐT: 024 37722728 – Hotline 18001091
              <span className="block md:inline">
                {" "}
                – Email: vnptmedia@vnpt.vn
              </span>
            </li>
          </ul>
        </div>
        <div className="flex items-end mx-auto lg:mx-0">
          <a
            href="http://online.gov.vn/Home/WebDetails/137716"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={bocongthuong}
              alt="Bộ công thương"
              className="mx-auto mt-6 w-[183px] h-[69px]"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
